import React, { useState, useEffect, useRef } from "react";
import ReactEcharts from "echarts-for-react";
import axios from "axios";
import API from "@/api";
import GbiArrow from "../../../../../assets/images/gbiArrow.svg";
import "./index.less";
import { Modal } from "antd";
import DetailTable from "../detailTable";

function BarData(props) {
  const {
    data: initialData = {},
    question_id,
    drillable,
    drillActions,
    changSpining,
  } = props;
  console.log(initialData, "柱状图数据");

  // 1. 状态管理：历史栈
  // 初始化时，放入第一层数据，标题设为 "全部"
  const [historyStack, setHistoryStack] = useState([
    {
      title: drillable === "true" || drillable === true ? "" : "",
      rawData: initialData,
    },
  ]);

  useEffect(() => {
    setHistoryStack([
      {
        title: drillable === "true" || drillable === true ? "" : "",
        rawData: initialData,
      },
    ]);
  }, [initialData]);
  // 当前显示的数据永远是栈顶的数据
  const currentStackItem = historyStack[historyStack.length - 1];
  const currentData = currentStackItem.rawData;

  // 2. 新增：使用 useRef 记录上一次点击的维度值
  const lastClickedDimRef = useRef(null);

  const [newDrillable, setNewDrillable] = useState(drillable);
  const { metric_fields = [], data: dData = [], dim_field = {} } = currentData;
  const [dimField, setDimField] = useState(currentData?.dim_field?.field);
  const [newActionId, setNewActionId] = useState(
    drillActions?.[0]?.action_id || "",
  );
  const [detailable, setDetailable] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const dimFieldRef = useRef(dimField);
  const drillableRef = useRef(newDrillable);
  const actionIdRef = useRef(newActionId);
  const xAxisData = (dData ? dData : []).map((item) => item[0]);
  const seriesConfig = (metric_fields ? metric_fields : []).map(
    (metric, index) => {
      return {
        name: metric.name, // 系列名称，如 "男生人数"
        type: "bar", // 图表类型，这里默认为柱状图
        // 数据映射：
        // 原始数据是 ['2025', 1362, 974]
        // 男生对应 index 1 (即 index + 1)，女生对应 index 2
        data: dData.map((row) =>
          typeof row[index + 1] === "number"
            ? row[index + 1]
            : typeof row[index + 1] === "string"
            ? row[index + 1].replace("%", "") * 1
            : 0,
        ),
        barWidth: 25, // 柱子宽度（占类目宽度的比例，可选）
        itemStyle: {
          borderRadius: [4, 4, 0, 0], // 柱子顶部圆角，更美观
        },
      };
    },
  );

  useEffect(() => {
    dimFieldRef.current = dimField;
  }, [dimField]);

  useEffect(() => {
    drillableRef.current = newDrillable;
  }, [newDrillable]);

  useEffect(() => {
    actionIdRef.current = newActionId;
  }, [newActionId]);

  const getOptions = () => {
    return {
      // title: {
      //   text: `${dim_field?.name}统计`,
      //   left: "center",
      // },
      tooltip: {
        trigger: "item", // 触发类型，'axis'表示触发整个坐标轴，'item'表示只触发当前数据项
        // axisPointer: {
        //   // 坐标轴指示器
        //   type: "shadow", // 阴影模式，体验更好
        // },
        // 2. 格式化显示内容
        // {b}: 数据名 (如 2025)
        // {c}: 数值 (如 1362)
        // {a}: 系列名称 (如 男生人数)
        formatter: function (params) {
          console.log(params);
          // params 是一个数组，包含当前 axis 上所有 series 的数据
          let result =
            params.name +
            "<br/>" +
            `${params.seriesName}: ${
              params.value.toLocaleString() + metric_fields?.[0]?.unit || ""
            }<br/>`; // 显示日期或类目
          return result;
        },
      },
      grid: {
        left: 30, // 左边距20px
        right: 30, // 右边距20px
        bottom: xAxisData.length < 15 ? "5%" : 50,
        top: 60,
        containLabel: true,
      },
      dataZoom:
        xAxisData.length < 15
          ? undefined
          : [
              {
                type: "inside",
                startValue: 0,
                endValue: 14,
              },
              {
                type: "slider",
              },
            ],
      xAxis: {
        type: "category",
        data: xAxisData,
        // name: dim_field.name,
        axisLabel: {
          // interval: 0,
          // // 设置宽度
          // width: 50,
          // // 超出部分截断并显示省略号
          // overflow: "truncate",
          // // 可选：设置省略号的内容
          // ellipsis: "...",
          rotate: xAxisData.length < 15 ? 0 : 15, // 稍微倾斜一点
          // 或者使用 formatter 进行截断处理
          formatter: function (value) {
            if (xAxisData.length < 15) {
              return value;
            } else {
              if (value.length > 5) {
                return value.substring(0, 5) + "...";
              }
              return value;
            }
          },
        },
        // 确保开启提示框组件，这样鼠标悬停时能看到全名
        tooltip: {
          show: true,
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: `{value}${metric_fields?.[0]?.unit || ""}`,
        },

        // value.toLocaleString() + `${metric_fields?.[0]?.unit || ""}`
      },

      series: seriesConfig,
      legend: {
        data: (metric_fields || []).map((m) => m.name), // 自动提取图例名称
        top: 10,
      },
    };
  };

  const handleChartClick = (params) => {
    //确保点击的是数据点
    if (params.componentType === "series" && params.dataIndex !== undefined) {
      const clickedDimName = params.name;

      // 3. 核心修复：防重判断
      // 如果当前点击的维度和上一次完全一样，直接 return，拦截重复请求
      if (lastClickedDimRef.current === clickedDimName) {
        console.log("这是重复的？");
        return;
      }
      if (newDrillable === true || newDrillable === "true") {
        changSpining(true);
      } else {
        changSpining(false);
      }
      // 更新 ref 为当前点击的维度
      lastClickedDimRef.current = clickedDimName;
      if (newDrillable === true || newDrillable === "true") {
        axios
          .post(API.getFilterAndNextData, {
            question_id,
            dim_field: dimFieldRef.current,
            dim_value: clickedDimName || "",
            // drill_path_id: actionIdRef?.current || "",
          })
          .then((res) => {
            const newData = res?.data?.chart_data || {};
            // 将新层级压入栈中
            setNewDrillable(res?.data?.drillable);
            setDetailable(res?.data?.detailable);
            setHistoryStack((prev) => {
              // 始终保留第一项（全部/根节点）的数据引用
              const firstItem = prev[0] || {
                title: "全部",
                rawData: initialData,
              };

              // 返回：[根节点, ...中间所有层级, 新节点]
              return [
                { title: "全部", rawData: firstItem.rawData },
                ...prev.slice(1),
                { title: clickedDimName, rawData: newData },
              ];
            });
            setDimField(res?.data?.chart_data?.dim_field?.field);
            setNewActionId(res?.data?.drill_actions?.[0]?.action_id || "");
            changSpining(false);
          })
          .catch((err) => {
            console.error("下钻请求失败", err);
          });
      } else {
        console.log("不能下钻啦");
      }
    }
  };

  // 3. 处理面包屑点击（返回）
  const handleBreadcrumbClick = (index) => {
    // 如果点击的是当前层级，不做操作
    if (index === historyStack.length - 1) return;

    // 截取数组，保留到点击的那一层
    console.log(index, "是不是最上面的一层");
    if (index === 0) {
      setHistoryStack((prev) => {
        console.log(prev.slice(0, index + 1));
        const item = prev.slice(0, index + 1)?.[0];
        return [{ ...item, title: "" }];
      });
    } else {
      setHistoryStack((prev) => prev.slice(0, index + 1));
    }
    lastClickedDimRef.current = "";
    setNewDrillable(true);
    setDetailable(false);
    setDimField(historyStack[index]?.rawData?.dim_field?.field);
  };

  const handleDetail = (params) => {
    if (params.componentType === "series" && params.dataIndex !== undefined) {
      if (detailable) {
        setDetailOpen(true);
        lastClickedDimRef.current = params?.name;
      }
    }
  };

  console.log(
    dimField,
    dimFieldRef.current,
    drillableRef.current,
    historyStack,
    "这个field是啥",
  );
  console.log("当前渲染用的X轴数据:", xAxisData);
  console.log("当前渲染用的Series数据:", seriesConfig);
  return (
    <>
      <ReactEcharts
        key={JSON.stringify(currentData)} // 或者使用 historyStack.length 作为 key
        style={{
          minHeight: "225px",
          maxHeight: "300px",
          width: "100%",
        }}
        option={getOptions()}
        onEvents={
          newDrillable === "true" || newDrillable === true
            ? {
                click: handleChartClick,
              }
            : {
                click: handleDetail,
              }
        }
        notMerge={true} // 推荐开启，确保每次 setOption 替换旧配置而不是合并
        lazyUpdate={true}
      />

      {/* 4. 渲染面包屑导航 */}
      <div
        className="historyStack"
        style={{
          padding: drillable === "true" || drillable === true ? "" : "unset",
        }}
      >
        <div>
          {historyStack.map((item, index) => (
            <span key={index}>
              {/* 如果不是最后一项，或者虽然是最后一项但还有下级（理论上最后一项是当前），都可以点击 */}
              <span
                style={
                  index === historyStack.length - 1
                    ? {}
                    : {
                        cursor: "pointer",
                        color: "#1C69FC",
                      }
                } // 当前层级不加手型样式
                onClick={() => handleBreadcrumbClick(index)}
              >
                {item.title}
              </span>
              {/* 如果不是最后一项，显示分隔符 */}
              {index < historyStack.length - 1 && (
                <span
                  style={{
                    padding: "0 10px ",
                  }}
                >
                  <img
                    style={{
                      width: "8px",
                    }}
                    src={GbiArrow}
                    alt=" "
                  />
                </span>
              )}
            </span>
          ))}
        </div>
        <div
          style={{
            color: "#aaa",
          }}
        >
          {drillable === "true" || drillable === true
            ? "点击维度可下钻"
            : detailable
            ? "点击维度可下钻"
            : undefined}
        </div>
      </div>

      <Modal
        title="明细表"
        destroyOnHidden
        open={detailOpen}
        onCancel={() => {
          setDetailOpen(false);
        }}
        width={800}
        footer={null}
      >
        <DetailTable
          question_id={question_id}
          drillActions={newActionId}
          dimField={dimField}
          dimValue={lastClickedDimRef.current}
        />
      </Modal>
    </>
  );
}

export default BarData;
